<template>
  <div class="sidebar sidebar-sticky dark" :class="{ active: active}">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="sidebar-header" id="sidebarBackground">
      <div class="img-user">
        <img src="../assets/images/download.png" alt="user-img" />
      </div>
      <div class="media-body" v-if="userName" v-on:click="active=true">
        <router-link :to="{ name: 'profile'}" class="nav-link with-sub" active>
          <h6>{{userName}}</h6>
          <span>{{phoneNumber}}</span>
        </router-link>
      </div>
      <div class="media-body" v-else>
        <h6>{{ $t('message.GuestUser') }}</h6>
      </div>
    </div>

    <div class="sidebar-body">
      <ul class="nav">
        <li class="nav-item" v-on:click="active=true">
          <router-link to="/" class="nav-link with-sub" active>{{ $t('message.Home') }}</router-link>
        </li>
        <li class="nav-item" v-if="userName" v-on:click="active=true">
          <router-link to="/wallet" class="nav-link with-sub" active>{{ $t('message.Wallet') }}</router-link>
        </li>
        <li class="nav-item" v-if="userName" v-on:click="active=true">
          <router-link
            :to="{ name: 'profile'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.MyProfile') }}</router-link>
        </li>
        <li class="nav-item" v-on:click="active=true">
          <router-link
            :to="{ name: 'contact-us'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.ContactUs') }}</router-link>
        </li>
        <li class="nav-item" v-on:click="active=true">
          <router-link
            :to="{ name: 'privacy-policy'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.PrivacyPolicy') }}</router-link>
        </li>
        <li class="nav-item" v-on:click="active=true">
          <router-link
            :to="{ name: 'about-us'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.AboutUs') }}</router-link>
        </li>
        <li class="nav-item" v-on:click="active=true">
          <router-link
            :to="{ name: 'terms-and-conditions'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.TermsandConditions') }}</router-link>
        </li>
        <li class="nav-item" v-on:click="active=true">
          <router-link
            :to="{ name: 'refund-policy'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.RefundPolicy') }}</router-link>
        </li>
        <li class="nav-item" v-if="userName" v-on:click="active=true">
          <router-link
            :to="{ name: 'my-order'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.MyOrder') }}</router-link>
        </li>
        <li class="nav-item" v-if="userName" v-on:click="active=true">
          <router-link
            :to="{ name: 'subcription'}"
            class="nav-link with-sub"
            active
          >{{ $t('message.Subscriptions') }}</router-link>
        </li>

        <!-- <li class="nav-item">
          <router-link to="/help-support" class="nav-link with-sub" active>Help & Support</router-link>
        </li>-->
        <li class="nav-item" v-on:click="logoutPopup" v-if="userName">
          <div class="nav-link with-sub">{{ $t('message.Logout') }}</div>
        </li>
        <li class="nav-item" v-else v-on:click="active=true">
          <router-link :to="{ name: 'register'}" class="nav-link with-sub">{{ $t('message.Login') }}</router-link>
        </li>
      </ul>
    </div>
    <b-modal id="logout" :title="$t('message.Logout')">
      <div class="addNewAddress">{{ $t('message.LogoutConfirm') }}</div>
      <template v-slot:modal-footer>
        <button
          class="btn btn-primary"
          v-on:click="logoutAccount('yes')"
        >{{ $t('message.YesButton') }}</button>
        <button
          class="btn btn-primary"
          v-on:click="logoutAccount('no')"
        >{{ $t('message.NoButton') }}</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { logout } from "./../services/api";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },
  data: function() {
    return {
      isLoading: false,
      fullPage: true,
      active: true,
      userName: localStorage.getItem("userName"),
      phoneNumber: localStorage.getItem("phoneNumber")
    };
  },
  mounted() {
    this.$parent.$on("toggleNav", () => {
      this.active = !this.active;
      this.userName = localStorage.getItem("userName");
      this.phoneNumber = localStorage.getItem("phoneNumber");
    });
  },
  watch: {
    $route(to, from) {
      this.active = true;
      this.userName = localStorage.getItem("userName");
      //  document.getElementById("background").style.background =
      //         result.data.data.layout_color;
    }
  },
  methods: {
    logoutPopup() {
      this.active = true;
      this.$bvModal.show("logout");
    },
    logoutAccount(val) {
      if (val == "yes") {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token")
        };
        this.isLoading = true;
        logout(requestData)
          .then(result => {
            this.$bvModal.hide("logout");
            if (result.data.successCode === 1) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
              this.isLoading = false;
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
              this.isLoading = false;
            }
          })
          .catch(error => {
            return;
          });
      } else {
        this.$bvModal.hide("logout");
      }
    }
  }
};
</script>